import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Customer } from 'src/app/shared/models/customer.model';
import { CommunicationService } from 'src/app/shared/services/communication.service';
import { CallModel } from 'src/app/shared/models/calllog.model';
import { MatStepper, MatHorizontalStepper, MatStep, MatDialogConfig, MatDialog } from '@angular/material';
import { ClientModel } from 'src/app/shared/models/client.model';
import { CallLogService } from 'src/app/shared/services/calllog.service';
import { CallDetailLogModel, CallLogModel } from 'src/app/shared/models/calllog.model';
import { GlobalConstants } from 'src/app/shared/constants/global-constants';
import { UserService } from 'src/app/shared/services/user.service';
import { ClientService } from 'src/app/shared/services/client.service';
//import { ToastrService } from 'ngx-toastr';
import { ClientDetailComponent } from 'src/app/client/client-detail/client-detail.component';

@Component({
  selector: 'app-find-customer-step',
  templateUrl: './find-customer-step.component.html',
  styleUrls: ['./find-customer-step.component.css']
})
export class FindCustomerStepComponent implements OnInit {
  displayedColumns: string[] = ['createTime', 'duration', 'note', 'ticketNo', 'loginName'];

  showCustomerList : boolean;
  selectedCustomer : ClientModel;
  clientType : string;
  destination : string;

  isCompleted : boolean;
  listCallLog : CallDetailLogModel [];
  @Input() call : CallModel;
  //@Input() stepper : MatHorizontalStepper;
  @Input() mystep : MatStep;
  @Output() onNextFirstStep: EventEmitter<any> = new EventEmitter<any>();
  userTypeList : string [];
  destinationList : string [];
  dialogConfig = new MatDialogConfig();
  //@Output() onCompleted: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private commservice : CommunicationService,
    private callservice : CallLogService,
    private userService : UserService,
    private clientService : ClientService,
    //private toastr : ToastrService,
    private dialog : MatDialog) {

    console.log("FindCustomerStepComponent");
    this.userTypeList = GlobalConstants.constUserTypeArray;
    this.destinationList = GlobalConstants.constCountryArray;
    this.clientType = "C";
    this.destination = userService.getCountryCode();

    this.dialogConfig.disableClose = true;
    this.dialogConfig.autoFocus = true;
    this.dialogConfig.width = "60%";
    this.dialogConfig.minWidth = "400px";
    this.dialogConfig.maxWidth = "700px";

  }

  ngOnInit() {
    this.selectedCustomer = null;
    this.showCustomerList = true;
  }

  onFindCustomer()
  {
    this.selectedCustomer = null;
    this.showCustomerList = true;

  }

  afterSelected(data : any)
  {
    this.listCallLog = null;
    this.selectedCustomer = data as ClientModel;
    this.showCustomerList = false;

    this.onFindCallLog();
/*
    var aa = new CallModel();

    aa.client = this.selectedCustomer;
    aa.isEnd = false;
    this.commservice.sendCallStatus(aa);
    this.showCustomerList = false;
*/

  }

  onEdit(item)
  {
    this.clientService.populateForm(item);
    this.dialogConfig.data = {
      result : false,
      data : item
    };

    let dialogRef = this.dialog.open(ClientDetailComponent, this.dialogConfig);
    dialogRef.afterClosed().subscribe(result => {

      if(this.dialogConfig.data.result)
      {
        console.log(true);
        this.selectedCustomer = this.dialogConfig.data.data;
       // this.refreshList();

      }

    });

  }

  onNext()
  {
   // this.selectedCustomer = data as ClientModel;
    var aa = new CallModel();

    aa.client = this.selectedCustomer;
    aa.isEnd = false;
    aa.clientType = this.clientType;
    aa.destination = this.destination;
    //this.commservice.sendCallStatus(aa);
    this.onNextFirstStep.emit(aa);

    this.showCustomerList = false;

   /*
    this.mystep.completed = true;
    this.stepper.next();
*/
  }


  getCountryString(code)
  {
    return GlobalConstants.getCountryString(code);
  }

  getCustomerString(type)
  {
    return GlobalConstants.getCustomerString(type);
  }

  onFindCallLog(){

    this.callservice.findDataByCustomer(this.selectedCustomer.clientId).subscribe(

      res => {
        this.listCallLog = res as CallDetailLogModel[];
      },
      err => {}
    );
  }

  public resetPage()
  {
    this.selectedCustomer = null;
    this.showCustomerList = true;
  }
}
